import {
  b2bDiscountsPromotionsGraphic,
  priceEditorGraphic,
} from '@sparklayer-io/spark-dash-ui/assets';
import { Card, MediaCard } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';

export function PriceListTools() {
  const { navigationHandler } = useHandlers();

  return (
    <Card>
      <Card.Header
        headingLevel="h2"
        primaryAction={{
          label: t('buttons:view_dashboard'),
          onClick: () => navigationHandler.navigate('/', { openInDashboard: true }),
        }}
      >
        {t('price_lists.help_cards.header')}
      </Card.Header>
      <Card.Body>
        <div className="grid grid-cols-2 gap-4 pb-1">
          <MediaCard
            headingLevel="h3"
            title={t('price_lists.help_cards.quantity_pricing.title')}
            description={t('price_lists.help_cards.quantity_pricing.description')}
            imgSrc={b2bDiscountsPromotionsGraphic}
            imgFit="contain"
            action={{
              content: t('price_lists.help_cards.quantity_pricing.action'),
              onClick: () =>
                navigationHandler.navigate('/pricing/discounts', { openInDashboard: true }),
            }}
          />

          <MediaCard
            headingLevel="h3"
            title={t('price_lists.help_cards.pack_size_rules.title')}
            description={t('price_lists.help_cards.pack_size_rules.description')}
            imgSrc={priceEditorGraphic}
            imgFit="contain"
            action={{
              content: t('price_lists.help_cards.pack_size_rules.action'),
              onClick: () =>
                navigationHandler.navigate('/pricing/editor', { openInDashboard: true }),
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
}
